import { ILoaiChungChiActionTypes } from "../../action-types/category/ILoaiChungChiActions";
import { ILoaiChungChiReducer } from "../../reducer-model/category/ILoaiChungChiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";


const iniState: ILoaiChungChiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    loaiChungChis: [],
}

export const LoaiChungChiReducer = (state = iniState, action: ILoaiChungChiActionTypes): ILoaiChungChiReducer => {
    switch (action.type) {
        case "LOAI_CHUNG_CHI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "LOAI_CHUNG_CHI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                loaiChungChis: action.payload,
            };
        case "LOAI_CHUNG_CHI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "LOAI_CHUNG_CHI_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                loaiChungChiEditing: action.payload,
            };
        case "LOAI_CHUNG_CHI_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "LOAI_CHUNG_CHI_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "LOAI_CHUNG_CHI_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "LOAI_CHUNG_CHI_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "LOAI_CHUNG_CHI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "LOAI_CHUNG_CHI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "LOAI_CHUNG_CHI_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}